import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { CannedCategory } from '../../../constants/common/CannedCategory';

const TemplateItemList = props => {
    const { isActive, templateList, editModal, selectedItem } = props;
    const [data, setData] = useState(templateList);
    const handleClick = item => {
        editModal(item);
    };

    useEffect(() => {
        if (!templateList.data) return;
    
        let filteredData = templateList.data;
        filteredData = filteredData.filter(item => item.enableAsActive === isActive);
        if (selectedItem === CannedCategory.SEND_MESSAGE || selectedItem === CannedCategory.INTERNAL_COMMENT) {
            filteredData = filteredData.filter(item => item.templateCategoryId === selectedItem);
        }
    
        setData(filteredData);
    }, [selectedItem, isActive, templateList]);

    return (
        <div className="margin-bottom-2em" id="templateList">
            <ConditionalRendering isTrue={!data?.length}>
                <div className="fixed-container">
                    <FormattedMessage id="ticket_management.no_templates_available" />
                </div>
            </ConditionalRendering>
            <ConditionalRendering isTrue={Array.isArray(data) && data.length > 0}>
                <div className="fixed-container">
                    <div className="style-div">
                        <FormattedMessage id="ticket_management.template_name" />
                    </div>
                    <ul>
                        {data?.map((item, index) => (
                            <li key={index}>
                                <button
                                    onClick={() => handleClick(item)}
                                    data-testid={`canned_response_template_${index}`}
                                    className="clickable-text clickable-text:hover margin-top-05em text-left"
                                >
                                    {item.templateName}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </ConditionalRendering>
        </div>
    );
};
export default TemplateItemList;
